const s = require("./coreMarketView.module.scss");

import { default as React, useEffect, useState } from "react";

import httpService from "core/infrastructure/http";
import { WithTranslation, withTranslation } from "react-i18next";
import { MaxNetPosDto, MaxExchangesDto, CheckVolumeDto, GetCheckVolumeResponse } from "core/backend/data";
import classNames from "classnames";
import BorderName from "components/borderName";
import { ApplicationState } from "core/app";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";

interface OwnProps {
    scrollPosition?: { col: number, row: number };
    maxNetPosData?: MaxNetPosDto;
    maxExchangeData?: MaxExchangesDto;
    applicationState: ApplicationState;
}

const List = ({ t, applicationState, maxNetPosData, maxExchangeData, scrollPosition }: OwnProps & WithTranslation) => {

    const hubs = applicationState.selectedHubs
        .filter(h => h.isDisplayed)
        .sort((h1, h2) => h1.id < h2.id ? -1 : 1);
    const filteredBorders = applicationState.selectedBorders.filter(h => h.isDisplayed);

    if (applicationState.hubToHubPosition["AT"] == null) {
        applicationState.addHubToHubExchange(filteredBorders.filter(x => ["AT_CZ", "AT_HU", "AT_SI", "BE_FR", "CZ_PL", "CZ_SK", "DE_AT", "DE_BE_DC", "DE_BE", "DE_CZ", "DE_FR", "DE_NL", "HR_HU", "HR_SI", "HU_RO", "HU_SI", "HU_SK", "NL_BE", "PL_DE", "PL_SK"].includes(x.id)));
        applicationState.addHubToHubPosition(hubs);
    }
    const hubToHubExchange = applicationState.hubToHubExchange;
    const hubToHubPos = applicationState.hubToHubPosition;

    const initialPtdfData: CheckVolumeDto = { id: 0, dateTimeUtc: "", tradesFeasable: false, errorMessage: "" };
    const [hubToHubResponse, setHubToHubResponse] = useState(initialPtdfData);
    const [loadingHubToHubResponse, setLoadingHubToHubResponse] = useState(false);
    const [hubResponse, setHubResponse] = useState(initialPtdfData);
    const [loadingHubResponse, setLoadingHubResponse] = useState(false);
    const [showPopup, setShowPopup] = useState(false);

    const setPopupHubResponse = (data: CheckVolumeDto) => {
        setHubResponse(data);
        //setShowPopup(data.errorMessage !== "");
    };

    const getHubTotal = (hub: string) => filteredBorders
        .reduce((total, border) => {
            if (border.id.startsWith(hub + "_")) {
                return total + (hubToHubExchange[border.id]?.value ?? 0);
            } else if (border.id.endsWith("_" + hub)) {
                return total - (hubToHubExchange[border.id]?.value ?? 0);
            } else {
                return total;
            }
        }, 0);

    const loadHubToHubResponse = async () => {
        setLoadingHubToHubResponse(true);
        const response = await httpService.apiPost<GetCheckVolumeResponse>({
            applicationState: applicationState,
            route: applicationState.apiService + "/data/checkVolume",
            query: {
                Utc: applicationState.selectedDate.toISOString(),
                hub_ALBE: getHubTotal("ALBE"),
                hub_ALDE: getHubTotal("ALDE"),
                hub_AT: getHubTotal("AT"),
                hub_BE: getHubTotal("BE"),
                hub_CZ: getHubTotal("CZ"),
                hub_DE: getHubTotal("DE"),
                hub_FR: getHubTotal("FR"),
                hub_HR: getHubTotal("HR"),
                hub_HU: getHubTotal("HU"),
                hub_NL: getHubTotal("NL"),
                hub_PL: getHubTotal("PL"),
                hub_RO: getHubTotal("RO"),
                hub_SI: getHubTotal("SI"),
                hub_SK: getHubTotal("SK"),
            },
            senderId: "MarketView"
        })();

        if (response.ok) {
            setHubToHubResponse(response.data.data);
        } else {
            setHubToHubResponse(initialPtdfData);
        }
        setLoadingHubToHubResponse(false);
    };

    const loadHubResponse = async () => {
        setLoadingHubResponse(true);
        const response = await httpService.apiPost<GetCheckVolumeResponse>({
            applicationState: applicationState,
            route: applicationState.apiService + "/data/checkVolume",
            query: {
                Utc: applicationState.selectedDate.toISOString(),
                hub_ALBE: (hubToHubPos["ALBE"]?.value ?? 0),
                hub_ALDE: (hubToHubPos["ALDE"]?.value ?? 0),
                hub_AT: (hubToHubPos["AT"]?.value ?? 0),
                hub_BE: (hubToHubPos["BE"]?.value ?? 0),
                hub_CZ: (hubToHubPos["CZ"]?.value ?? 0),
                hub_DE: (hubToHubPos["DE"]?.value ?? 0),
                hub_FR: (hubToHubPos["FR"]?.value ?? 0),
                hub_HR: (hubToHubPos["HR"]?.value ?? 0),
                hub_HU: (hubToHubPos["HU"]?.value ?? 0),
                hub_NL: (hubToHubPos["NL"]?.value ?? 0),
                hub_PL: (hubToHubPos["PL"]?.value ?? 0),
                hub_RO: (hubToHubPos["RO"]?.value ?? 0),
                hub_SI: (hubToHubPos["SI"]?.value ?? 0),
                hub_SK: (hubToHubPos["SK"]?.value ?? 0),
            },
            senderId: "MarketView"
        })();

        if (response.ok) {
            setPopupHubResponse(response.data.data);
        } else {
            setPopupHubResponse(initialPtdfData);
        }
        setLoadingHubResponse(false);
    };

    const handlehubToHubExchangeChange = (id: string, e: string, commit: boolean) => {
        const float = parseFloat(e);
        applicationState.handleHubToHubExchangeChange(id, commit ? float.toString() : e, []);
        setHubToHubResponse(initialPtdfData);

        /*if (commit) {
            (async function runAsync() {
                await loadHubToHubResponse();
            })();
        }*/
    };

    const handleHubToHubPosChange = (id: string, e: string, commit: boolean) => {
        const float = parseFloat(e);
        applicationState.handleHubToHubPositionChange(id, commit ? float.toString() : e);
        setPopupHubResponse(initialPtdfData);

        /*if (commit) {
            (async function runAsync() {
                await loadHubResponse();
            })();
        }*/
    };

    useEffect(() => {
        setHubToHubResponse(initialPtdfData);
        setPopupHubResponse(initialPtdfData);
    }, [applicationState.selectedDate]);

    const oppositeBorder = (border: string) => {
        const split = border.split("_");
        if (split.length === 2) return split[1] + "_" + split[0];
        if (split.length === 3) return split[1] + "_" + split[0] + "_" + split[2];
        return "";
    }

    const sumAlegro = parseFloat(hubs.filter(h => h.id === "ALBE" || h.id === "ALDE").reduce((total, hub) => total + hubToHubPos[hub.id]?.value ?? 0, 0).toFixed(5));
    const sumOthers = parseFloat(hubs.filter(h => h.id !== "ALBE" && h.id !== "ALDE").reduce((total, hub) => total + hubToHubPos[hub.id]?.value ?? 0, 0).toFixed(5));

    return (
        <div className="shadow-sm bg-white rounded" style={{ margin: "1rem" }} >
            <div className={classnames(s.lightBox, showPopup ? "" : s.hidden)} onClick={() => { setShowPopup(false); }} />
            <div className={classnames(s.popup, "shadow", showPopup ? "" : s.hidden)}>
                <FontAwesomeIcon icon={faWindowClose} className={s.closeButton} onClick={() => { setShowPopup(false); }} />
                <br />
                {hubResponse.errorMessage}
            </div>
            <div className={s.whiteBanner} >
                <div className={s.firstColumn} ></div>
                <div className={s.secondColumn}>
                    <div><h1 style={{ display: "inline", paddingRight: "1rem" }}>1</h1><h3 style={{ display: "inline" }}>Check volume</h3></div>
                </div>
                <div className={s.thirdColumn} >
                    <div><h1 style={{ display: "inline", paddingRight: "1rem" }}>2</h1><h3 style={{ display: "inline" }}>Max volume</h3></div>
                </div>
            </div>
            <div className={s.whiteBanner} >
                <div className={s.firstColumn} ></div>
                <div className={s.secondColumn}>
                    <div className={s.small}>Here you can check the simultaneous execution of trading volumes of the market involved in the Core Market Coupling</div>
                </div>
                <div className={s.thirdColumn} >
                    <div className={s.small}>Here you can find the maximal trade volumes (MWh/h) which can be physically transported between two Hubs under the condition that no other trade is executed between other  Hubs</div>
                </div>
            </div>
            <div className={s.grayBanner}  >
                <div className={s.firstColumn} >Hub-to-Hub<br /><b>Exchanges</b></div>
                <div className={s.secondColumn}>
                    <table className={s.table}>
                        <thead><tr><th></th><th>Hub-to-Hub</th><th style={{ width: "15rem" }}>Test 1</th></tr></thead>
                        <tbody>
                            <tr><td></td><td></td><td rowSpan={50}>
                                {loadingHubToHubResponse
                                    ? <div className={classNames(s.validator, s.inbetween, s.firstLastRightInput)} style={{ width: "15rem" }}><span>Checking...</span></div>
                                    : hubToHubResponse.id === 0
                                        ? <div className={classNames(s.validator, s.inbetween, s.firstLastRightInput)} style={{ width: "15rem" }} onClick={() => {
                                            (async function runAsync() {
                                                await loadHubToHubResponse();
                                            })();
                                        }}><span>Click here to test.</span></div>
                                        : (hubToHubResponse.errorMessage ?? "") == ""
                                            ? hubToHubResponse.tradesFeasable
                                                ? <div className={classNames(s.validator, s.valid, s.firstLastRightInput)} style={{ width: "15rem" }}><span>Trades feasible</span></div>
                                                : <div className={classNames(s.validator, s.wrong, s.firstLastRightInput)} style={{ width: "15rem" }}><span>Constrained Transmission System</span></div>
                                            : <div className={classNames(s.validator, s.error, s.firstLastRightInput)} style={{ width: "15rem" }}><span>{hubToHubResponse.errorMessage}</span></div>
                                }
                            </td></tr>
                            {filteredBorders.filter(x => hubToHubExchange[x.id] != null).map((border) => <tr key={border.id}>
                                <td className={s.borderLabel}><BorderName text={border.text.replace("DE►BE", "DE►BE (DC)")} /></td>
                                <td><input className={s.firstLeftInput} type="text" value={hubToHubExchange[border.id].text}
                                    onChange={(e) => handlehubToHubExchangeChange(border.id, e.target.value, false)}
                                    onBlur={(e) => handlehubToHubExchangeChange(border.id, e.target.value, true)}
                                    onKeyDown={(e) => { if (e.keyCode === 13) e.currentTarget.blur(); }} /></td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                <div className={s.thirdColumn} >
                    <table className={s.table}>
                        <thead><tr><th></th><th>Direction ►</th><th>◄ Direction </th></tr></thead>
                        <tbody>
                            {filteredBorders.filter(x => hubToHubExchange[x.id] != null).map((border) => <tr key={border.id}>
                                <td className={s.borderLabel}><BorderName text={border.text} /></td>
                                <td><input readOnly className={s.firstLeftInput} type="text" value={maxExchangeData && eval("maxExchangeData.border_" + border.id.toUpperCase().replace("_DC", ""))} /></td>
                                <td><input readOnly className={s.firstRightInput} type="text" value={maxExchangeData && eval("maxExchangeData.border_" + oppositeBorder(border.id.toUpperCase()).replace("_DC", ""))} /></td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className={s.spacer} />
            <div className={s.grayBanner}  >
                <div className={s.firstColumn} >Hub-to-Hub<br /><b>Positions</b></div>
                <div className={s.secondColumn} >
                    <table className={s.table}>
                        <thead><tr><th></th><th>Hub positions</th><th style={{ width: "5rem" }}>Test 1</th><th style={{ width: "10rem" }}>Test 2</th></tr></thead>
                        <tbody>
                            <tr>
                                <td ></td><td></td>
                                <td rowSpan={20}>
                                    {sumAlegro !== 0
                                        ? <div className={classNames(s.validator, s.wrong)} style={{ width: "5rem" }}><span>KO</span></div>
                                        : sumOthers !== 0
                                            ? <div className={classNames(s.validator, s.wrong)} style={{ width: "5rem" }}><span>KO</span></div>
                                            : <div className={classNames(s.validator, s.valid)} style={{ width: "5rem" }}><span>OK</span></div>
                                    }
                                </td>
                                <td rowSpan={20}>
                                    {loadingHubResponse
                                        ? <div className={classNames(s.validator, s.inbetween, s.firstLastRightInput)} style={{ width: "10rem" }}><span>Checking...</span></div>
                                        : hubResponse.id === 0
                                            ? <div className={classNames(s.validator, s.inbetween, s.firstLastRightInput)} style={{ width: "10rem" }} onClick={() => {
                                                (async function runAsync() {
                                                    await loadHubResponse();
                                                })();
                                            }}><span>Click here to test.</span></div>
                                            : (hubResponse.errorMessage ?? "") == ""
                                                ? hubResponse.tradesFeasable
                                                    ? <div className={classNames(s.validator, s.valid, s.firstLastRightInput)} style={{ width: "10rem" }}><span>Trades feasible</span></div>
                                                    : <div className={classNames(s.validator, s.wrong, s.firstLastRightInput)} style={{ width: "10rem" }}><span>Constrained Transmission System</span></div>
                                                : <div className={classNames(s.validator, s.error, s.firstLastRightInput)} style={{ width: "10rem" }}><span>{hubResponse.errorMessage}</span></div>

                                    }
                                </td>
                            </tr>
                            {hubs.map((hub) => <tr key={hub.id}>
                                <td className={s.borderLabel}>{t("common_hubs:" + hub.id)}</td>
                                <td><input className={s.firstLeftInput} type="text" value={hubToHubPos[hub.id] ? hubToHubPos[hub.id].text : ""}
                                    onChange={(e) => handleHubToHubPosChange(hub.id, e.target.value, false)}
                                    onBlur={(e) => handleHubToHubPosChange(hub.id, e.target.value, true)}
                                    onKeyDown={(e) => { if (e.keyCode === 13) e.currentTarget.blur(); }} /></td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                <div className={s.thirdColumn} >
                    <table className={s.table}>
                        <thead><tr><th></th><th>Export</th><th>Import</th></tr></thead>
                        <tbody>
                            {hubs.map((hub) =>
                                <tr key={hub.id}>
                                    <td className={s.borderLabel}>{t("common_hubs:" + hub.id)}</td>
                                    <td><input readOnly className={s.firstLeftInput} type="text" value={maxNetPosData && eval("maxNetPosData.max" + hub.id.toUpperCase())} /></td>
                                    <td><input readOnly className={s.firstLeftInput} type="text" value={maxNetPosData && eval("maxNetPosData.min" + hub.id.toUpperCase())} /></td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            <div className={s.spacer}>&nbsp;</div>
        </div>
    );
};

const translated = withTranslation()(List);

export default translated;